'use client';

import { twMerge } from 'tailwind-merge';
import { SelectSnaps } from './SelectSnaps';
import type { SnapCurationListItem } from './type';

export interface SelectSnapsSelectionStepProps {
  className?: string;
  defaultCheckedSnaps: SnapCurationListItem[];
  onSubmit: () => void;
}

export function SelectSnapsSelectionStep({
  className,
  defaultCheckedSnaps,
  onSubmit,
}: SelectSnapsSelectionStepProps) {
  return (
    <div className={twMerge('flex w-full flex-col grow pb-[72px]!', className)}>
      <SelectSnaps defaultCheckedSnaps={defaultCheckedSnaps} onSubmit={onSubmit} />
    </div>
  );
}
